import { FunctionComponent, useCallback, useContext, useMemo } from 'react';
import { ConfigContext } from '../../context';
import {
  ChannelSwitcher,
  ConfigurationLink,
  getWebAppUrl,
  useAppSelector,
  useIsNarrowViewport,
} from '../../shared';
import { Footer } from '../Footer';
import { MenuAdmin } from '../MenuAdmin';

import classNames from 'classnames';
import classes from './SidebarAdmin.module.scss';

interface SidebarAdminProps {
  onMobilePanelClose?: () => void;
}

export const SidebarAdmin: FunctionComponent<SidebarAdminProps> = ({ onMobilePanelClose }) => {
  const isNarrowViewport = useIsNarrowViewport();

  const { headerLinks } = useContext(ConfigContext).config.elements;

  const { channels } = useAppSelector(({ channels }) => channels);

  const onChannelChange = useCallback(
    (channelId: number) => {
      const selectedChannel = channels
        .find(({ id }) => id === channelId)
        ?.subdomain.replace(/\s/g, '');

      if (!selectedChannel) {
        return;
      }

      window.location.replace(`${getWebAppUrl(selectedChannel)}/admin`);
    },
    [channels]
  );

  const renderChannelSwitcher = useMemo(() => Boolean(channels.length), [channels]);

  return (
    <div
      className={classNames(classes['sidebar'], {
        [classes['sidebar--narrow']]: isNarrowViewport,
      })}
    >
      {renderChannelSwitcher && <ChannelSwitcher onChange={onChannelChange} />}

      <nav>
        <MenuAdmin />
      </nav>

      {isNarrowViewport && Boolean(headerLinks.length) && (
        <div className={classes['sidebar__header-links']}>
          {headerLinks.map((link) => (
            <ConfigurationLink key={link.title} link={link} clickCallback={onMobilePanelClose} />
          ))}
        </div>
      )}

      <Footer />
    </div>
  );
};
